<template>
  <!--    vision-area-start-->
  <div class="vision-area">
    <div class="container">
      <div class="row  justify-content-center">
        <div class="col-lg-13 col-md-3 rk-buttons border rounded-3 align-middle text-center ">
          <router-link to="/digitalleaders2023/meta" class="align-middle"
            ><strong>Meta Ranking</strong> <br />Best universities for Digital Learning &
            Studies</router-link
          >
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row  justify-content-center">
        <div
          class="col-lg-3 col-md-3 rk-buttons border rounded-3 align-middle"
          v-for="box in boxes"
          :key="box.id"
        >
          <router-link :to="box.buttonLink" class="align-middle">{{ box.title }}</router-link>
        </div>
      </div>
    </div>
  </div>
  <!--    vision-area-end-->
</template>

<script>
import { getCollection, getArticleById } from '@/api/navItems';
import { translate } from '@/lib/utils';

export default {
  created() {
    getCollection('category-boxes', this.condition).then(res => {
      console.log(this.condition);
      this.boxes = res;
    });
    getArticleById(this.articleId).then(res => {
      this.article = translate(res);
    });
  },
  props: {
    slug: {
      type: String
    },
    articleId: {
      type: String
    },
    condition: {
      type: Object
    },
    classes: {
      type: String,
      default: 'single-team vision '
    }
  },
  data() {
    return {
      article: {},
      boxes: []
    };
  }
};
</script>

<style lang="scss" scoped>
.section-title h3 {
  max-width: 580px;
  margin-left: auto;
  margin-right: auto;
}

.section-title p {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.icon-colors {
  background: red;
}
</style>
